import { Component, input } from '@angular/core';
import { FormRangesParams } from "../../../../../../shared/components/form-with-ranges/form-with-ranges.types";
import { AudienceGeoParams, AudienceParams } from "../../../../../types/records-table.types";
import { titlesForAudienceGeo } from "../../configs/edit-audience-modal-config";
import {
  FormWithRangesComponent
} from "../../../../../../shared/components/form-with-ranges/form-with-ranges.component";

@Component({
  selector: 'app-audience-geo-card',
  standalone: true,
  imports: [
    FormWithRangesComponent
  ],
  templateUrl: './audience-geo-card.component.html',
  styleUrl: './audience-geo-card.component.scss'
})
export class AudienceGeoCardComponent {
  audienceParams = input.required<AudienceParams>();
  isEditEnabled = input<boolean>(true);

  public prepareFormParamsForGeoTab(): Array<FormRangesParams> {
    return this.audienceParams().geo.map((geoParam: AudienceGeoParams) => {
      return {
        key: geoParam.name,
        name: titlesForAudienceGeo[geoParam.name],
        value: geoParam.value ?? 0
      }
    })
  }

  public handleGeoFormRangeChange(formRangeData: Array<FormRangesParams>): void {
    this.updateGeoDataAccordingToFormRangeData(formRangeData);
  }

  private updateGeoDataAccordingToFormRangeData(formRangeData: Array<FormRangesParams>): void {
    formRangeData.forEach((formRangeParam: FormRangesParams) => {
      const indexForParamUpdate = this.audienceParams().geo.findIndex((param: AudienceGeoParams) => param.name == formRangeParam.key);
      this.audienceParams().geo[indexForParamUpdate].value = formRangeParam.value;
    });
  }
}
